import { useContext } from "react";
import { NavContext } from "../Nav/NavContext";
import { closeMenu as closeMenuAction, openMenu as openMenuAction } from "../Nav/reducer";

export function useMenu() {
  const [state, dispatch] = useContext(NavContext);
  const { isMenuOpen: isOpen, menuItems } = state;

  const toggleMenu = () => dispatch(isOpen ? closeMenuAction() : openMenuAction());
  const openMenu = () => dispatch(openMenuAction());
  const closeMenu = () => dispatch(closeMenuAction());

  return { isOpen, toggleMenu, closeMenu, openMenu, items: menuItems };
}
